import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const VACIO = { nombre: '', apellidos: '', dni: '', email: '', password: '', rol: 'maquinista' };

export default function Maquinistas() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(VACIO);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/usuarios/').then(r => setUsuarios(r.data)).finally(() => setLoading(false));
  };

  const guardar = async () => {
    if (!form.nombre || !form.apellidos || !form.dni || !form.email || !form.password) {
      setMsg('Todos los campos son obligatorios'); return;
    }
    setSaving(true);
    try {
      await api.post('/auth/registro', form);
      setMsg('Usuario creado correctamente');
      setModal(false);
      setForm(VACIO);
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Error al crear usuario');
    } finally {
      setSaving(false);
    }
  };

  const maquinistas = usuarios.filter(u => u.rol === 'maquinista');
  const staff = usuarios.filter(u => u.rol === 'staff');

  const renderBloque = (lista, titulo) => (
    <div style={{ marginBottom: 28 }}>
      <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span>{titulo}</span>
        <span style={{ background: '#f0f0f0', borderRadius: 20, padding: '2px 8px', fontSize: 11, color: '#888' }}>{lista.length}</span>
      </div>
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f8f6' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Nombre</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>DNI</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Email</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Rol</th>
            </tr>
          </thead>
          <tbody>
            {lista.map(u => (
              <tr key={u.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 14px', fontWeight: 500 }}>{u.nombre} {u.apellidos}</td>
                <td style={{ padding: '10px 14px', color: '#888' }}>{u.dni}</td>
                <td style={{ padding: '10px 14px', color: '#888' }}>{u.email}</td>
                <td style={{ padding: '10px 14px' }}>
                  <span style={{
                    background: u.rol === 'staff' ? '#e6f1fb' : '#f0f0f0',
                    color: u.rol === 'staff' ? '#185fa5' : '#555',
                    border: `1px solid ${u.rol === 'staff' ? '#85b7eb' : '#ddd'}`,
                    borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 500
                  }}>
                    {u.rol}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Usuarios</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Maquinistas y staff del sistema</p>
        </div>
        <button onClick={() => { setModal(true); setForm(VACIO); }} style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          + Nuevo usuario
        </button>
      </div>

      {msg && (
        <div style={{ background: '#eaf3de', border: '1px solid #97c459', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#3b6d11' }}>
          {msg}
        </div>
      )}

      {renderBloque(maquinistas, 'Maquinistas')}
      {renderBloque(staff, 'Staff')}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModal(false); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 440, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>Nuevo usuario</h3>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Nombre *</label>
                <input value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Apellidos *</label>
                <input value={form.apellidos} onChange={e => setForm({ ...form, apellidos: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>DNI *</label>
                <input value={form.dni} onChange={e => setForm({ ...form, dni: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Rol *</label>
                <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="maquinista">Maquinista</option>
                  <option value="staff">Staff</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Email *</label>
              <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Contraseña *</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>

            {msg && (
              <div style={{ background: '#fff0f0', border: '1px solid #fcc', borderRadius: 8, padding: '8px 12px', fontSize: 13, color: '#c00', marginBottom: 14 }}>
                {msg}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={guardar} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : 'Crear usuario'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
